import { useOnboardingAction } from '@hooks'
import { WarningYellowIcon } from '@icons'
import { OnboardingActions, OnboardingStatuses, useMerchantQry } from 'mmfintech-backend-api'
import { tr } from 'mmfintech-commons'
import { Button } from 'mmfintech-portal-commons'

import './OnboardingBanner.scss'

function OnboardingBanner() {
  const { merchant } = useMerchantQry()
  const { onboardingAction, startOrContinueOnboarding } = useOnboardingAction()

  switch (onboardingAction) {
    case OnboardingActions.NOT_STARTED:
      return (
        <div className='banner-wrapper'>
          <div className='centered mr-2'>
            <WarningYellowIcon />
          </div>
          <div className='text-body'>
            <div className='onboarding-resume-header'>
              {tr('PORTAL.ONBOARDING.RESUME.TITLE', 'Complete your account')}
            </div>
            {tr(
              'PORTAL.ONBOARDING.RESUME.CONTENT',
              'Verify to get access to all features and increased payment limits.'
            )}
          </div>
          <div className='centered ml-2'>
            <Button
              className='banner-large-button'
              data-test='start-onboarding'
              onClick={startOrContinueOnboarding}
              text={tr('PORTAL.ONBOARDING.VERIFY_BUTTON', 'Verify')}
            />
          </div>
        </div>
      )

    case OnboardingActions.ONBOARDING:
      return (
        <div className='banner-wrapper'>
          <div className='centered mr-2'>
            <WarningYellowIcon />
          </div>
          <div className='text-body'>
            <div className='onboarding-resume-header'>
              {merchant?.onboardingStatus === OnboardingStatuses.APPROVED_EXPIRING_DOCUMENT
                ? tr('PORTAL.ONBOARDING.EXPIRING_DOCUMENTS.TITLE', 'Expiring document')
                : tr('PORTAL.ONBOARDING.RESUME.TITLE', 'Complete your account')}
            </div>
            {merchant?.onboardingStatus === OnboardingStatuses.APPROVED_EXPIRING_DOCUMENT
              ? tr(
                  'PORTAL.ONBOARDING.EXPIRING_DOCUMENTS.MESSAGE',
                  'Your document is expiring, upload newer one to avoid limitation of services'
                )
              : tr(
                  'PORTAL.ONBOARDING.RESUME.CONTENT',
                  'Verify to get access to all features and increased payment limits.'
                )}
          </div>
          <div className='centered ml-2'>
            <Button
              data-test='start-onboarding'
              onClick={startOrContinueOnboarding}
              text={tr('FRONTEND.BUTTONS.CONTINUE', 'Continue')}
            />
          </div>
        </div>
      )

    case OnboardingActions.DOCUMENTS:
      return (
        <div className='banner-wrapper'>
          <div className='centered mr-2'>
            <WarningYellowIcon />
          </div>
          <div className='text-body'>
            <div className='onboarding-resume-header'>
              {tr('PORTAL.ONBOARDING.ADDITIONAL_DOCUMENTS.TITLE', 'Complete your account')}
            </div>
            {tr(
              'PORTAL.ONBOARDING.ADDITIONAL_DOCUMENTS.CONTENT',
              'Complete the final step of your account activation - additional documents'
            )}
          </div>
          <div className='centered ml-2'>
            <Button
              text={tr('FRONTEND.BUTTONS.CONTINUE', 'Continue')}
              data-test='start-onboarding'
              onClick={startOrContinueOnboarding}
            />
          </div>
        </div>
      )

    case OnboardingActions.QUESTIONNAIRE:
      return (
        <div className='banner-wrapper'>
          <div className='centered mr-2'>
            <WarningYellowIcon />
          </div>
          <div className='text-body'>
            <div className='onboarding-resume-header'>
              {tr('PORTAL.ONBOARDING.QUESTIONNAIRE.TITLE', 'Questionnaire')}
            </div>
            {tr(
              'PORTAL.ONBOARDING.QUESTIONNAIRE.CONTENT',
              'Complete the questionnaire in order to proceed with the account onboarding'
            )}
          </div>
          <div className='centered ml-2'>
            <Button
              data-test='start-onboarding'
              text={tr('PORTAL.ONBOARDING.QUESTIONNAIRE.START_BUTTON', 'Start')}
              onClick={startOrContinueOnboarding}
            />
          </div>
        </div>
      )

    case OnboardingActions.APPLICATION_FEE:
      return (
        <div className='banner-wrapper'>
          <div className='centered mr-2'>
            <WarningYellowIcon />
          </div>
          <div className='text-body'>
            <div className='onboarding-resume-header'>
              {tr('PORTAL.ONBOARDING.SETUP_FEE.TITLE', 'Complete your account')}
            </div>
            {tr(
              'PORTAL.ONBOARDING.SETUP_FEE.CONTENT',
              'You need to pay your application fee to enable your primary account.'
            )}
          </div>
          <div className='centered ml-2'>
            <Button
              className='banner-large-button'
              data-test='setup-fee-button'
              onClick={startOrContinueOnboarding}
              text={tr('PORTAL.ONBOARDING.SETUP_FEE.PAY_BUTTON', 'Pay now')}
            />
          </div>
        </div>
      )

    case OnboardingActions.UNDER_REVIEW:
      return (
        <div className='banner-wrapper'>
          <div className='centered mr-2'>
            <WarningYellowIcon />
          </div>
          <div className='text-body centered'>
            <div className='onboarding-resume-header'>
              {tr('PORTAL.ONBOARDING.UNDER_REVIEW', 'Your account verification is under review.')}
            </div>
          </div>
        </div>
      )

    default:
      if (merchant?.onboardingStatus === OnboardingStatuses.REJECTED_FINAL) {
        return (
          <div className='banner-wrapper'>
            <div className='centered mr-2'>
              <WarningYellowIcon />
            </div>
            <div className='text-body centered'>
              <div className='onboarding-resume-header'>
                {tr(
                  'PORTAL.ONBOARDING.REJECTED',
                  'Please contact Customer Service to get support on your account verification.'
                )}
              </div>
            </div>
          </div>
        )
      }
  }

  return null
}

export default OnboardingBanner
